/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PasswordCredentialParams
 */
export interface PasswordCredentialParams {
    /**
     * A hash of a password, in the one of the formats accepts by SlashID.
     * SlashID supports the following hashing functions:
     *   - pbkdf2
     *   - bcrypt
     *   - argon2i
     *   - argon2id
     * Hashes created using a function not listed here will be rejected.
     * In all of these cases, SlashID accepts hashes in the format described [here](https://github.com/P-H-C/phc-string-format/blob/master/phc-sf-spec.md).
     * The only departure from the specification described is that the hashing function version can include the characters [a-z0-9], to accommodate bcrypt versions (2, 2a, 2b, 2x, 2y).
     * SlashID also accepts password hashes in the format used by [bcrypt](https://www.usenix.org/legacy/events/usenix99/provos/provos.pdf).
     * If a password hash matches this format, it is assumed that the hashing function used was bcrypt.
     * If any other hashing function was used to hash the password, the hash must be in the SlashID hash format.
     * @type {string}
     * @memberof PasswordCredentialParams
     */
    password_hash: string;
}

/**
 * Check if a given object implements the PasswordCredentialParams interface.
 */
export function instanceOfPasswordCredentialParams(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password_hash" in value;

    return isInstance;
}

export function PasswordCredentialParamsFromJSON(json: any): PasswordCredentialParams {
    return PasswordCredentialParamsFromJSONTyped(json, false);
}

export function PasswordCredentialParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordCredentialParams {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password_hash': json['password_hash'],
    };
}

export function PasswordCredentialParamsToJSON(value?: PasswordCredentialParams | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password_hash': value.password_hash,
    };
}

